/** Convergência da quadrícula: o ângulo entre o norte da grelha de um CRS
 *  projectado e o norte verdadeiro, num ponto. Calcula-se pelo proj4 (um
 *  passo pequeno para norte), por isso serve para qualquer projecção.
 *
 *  Devolve graus, sentido anti-horário, do norte da grelha para o norte
 *  verdadeiro. Para pôr um modelo desenhado na grelha num referencial de
 *  norte verdadeiro roda-se -convergência (anti-horário), o que no KML é
 *  um heading de +convergência (o heading do KML é horário). */

export interface Conversor {
  /** Grelha (E, N) para longitude, latitude. */
  forward(p: [number, number]): [number, number]
  /** Longitude, latitude para a grelha (E, N). */
  inverse(p: [number, number]): [number, number]
}

export function convergenciaGraus(conv: Conversor, e: number, n: number): number {
  const [lon, lat] = conv.forward([e, n])
  const [e2, n2] = conv.inverse([lon, Math.min(89.9, lat + 1e-4)])
  return (Math.atan2(-(e2 - e), n2 - n) * 180) / Math.PI
}
